module.exports = __webpack_public_path__ + "static/media/homeblckicon.b59ace25.svg";